import { GoTrueClient } from "@supabase/supabase-js";
import { authFrontDoorForHostname, authStorageKey } from "@/lib/supabase/auth-front-door";

/**
 * GoTrue auth client (issue #5; root-path fix 2026-06-29) — SESSION ONLY.
 *
 * The dedicated LMS GoTrue (lms-auth.imam-us.org) is raw `supabase/gotrue` with NO
 * Kong/PostgREST gateway in front, so its endpoints live at the service ROOT
 * (`/token`, `/user`, `/recover`, `/logout`, …) — there is NO `/auth/v1` prefix
 * (every `/auth/v1/*` path 404s). supabase-js `createClient` hard-appends
 * `/auth/v1` to the URL, which would 404 here, so we construct the GoTrue client
 * directly against the root URL instead. `VITE_SUPABASE_URL` is therefore the bare
 * GoTrue origin (`https://lms-auth.imam-us.org`), not an `/auth/v1` mount. The JWT
 * `iss` claim still carries `/auth/v1` (a string, decoupled from the HTTP path).
 *
 * Auth-only: all LMS data goes through the FastAPI backend (lib/api/client.ts); this
 * client never touches PostgREST/Realtime.
 *
 * - `storageKey` is LMS-specific so a session never collides with standalone-search
 *   on a shared parent domain.
 * - PKCE + detectSessionInUrl so the password-recovery email link is consumed.
 */
const frontDoor = authFrontDoorForHostname();

if (!frontDoor) {
  throw new Error("This address has no configured tenant auth front door");
}

if (frontDoor.transition === "tenant-internal") {
  window.localStorage.removeItem("imam-lms-auth");
}

const auth = new GoTrueClient({
  url: frontDoor.url,
  headers: { apikey: frontDoor.anonKey },
  storageKey: authStorageKey(frontDoor),
  persistSession: true,
  autoRefreshToken: true,
  detectSessionInUrl: true,
  flowType: "pkce",
});

// Keep the `{ auth }` shape so existing `supabase.auth.*` call sites are unchanged.
export const supabase = { auth };
